import React from 'react';
/**
 * FlexContext
 * @type {React.Context<{store: {}}>}
 */
export var FlexContext = /*#__PURE__*/React.createContext({
  direction: 'vertical',
  gutter: 0,
  children: []
});